import { Component, inject, Input, OnInit } from '@angular/core';
import { Tag } from 'primeng/tag';
import { I18nService } from '../../../core/services/i18n.service';

@Component({
  selector: 'sps-payment-status-tag',
  imports: [
    Tag
  ],
  templateUrl: './sps-payment-status-tag.component.html',
})
export class SpsPaymentStatusTagComponent implements OnInit{

  i18n = inject(I18nService);

  @Input() status: 'LIVE' | 'TEST' | 'CLOSED' | 'DELETED';

  tagValue: string;
  tagSeverity: 'secondary' | 'success' | 'danger' | 'info' | 'warn' | 'contrast';

  ngOnInit() {
    switch (this.status) {
      case 'TEST':
        this.tagValue = 'Test';
        this.tagSeverity = 'secondary';
        break;
      case 'LIVE':
        this.tagValue = 'Live';
        this.tagSeverity = 'success';
        break;
      case 'CLOSED':
        this.tagValue = this.i18n.i18nLng()['CLOSED'];
        this.tagSeverity = 'danger';
        break;
      case 'DELETED':
        this.tagValue = this.i18n.i18nLng()['DELETED'];
        this.tagSeverity = 'danger';
        break;
    }
  }
}
